<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content>
    {{ message }}
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button (click)="dialogRef.close(false)">
        Cancel
    </button>

    <button matButton="outlined"  (click)="dialogRef.close(true)">
        Confirm
    </button>
</mat-dialog-actions>